import { connect } from 'react-redux';
import Component from './Component';

import onChangeTable from './Handlers/onChangeTable';
import onClickEdit from './Handlers/onClickEdit';

const mapStateToProps = (state) => ({
  caveats: state.screens.Caveats.caveats,
  pagination: state.screens.Caveats.pagination,
  fetching: state.screens.Caveats.fetching,
  serviceTypes: state.core.serviceTypes
});

const actionCreators = {
  onChangeTable,
  onClickEdit
};

export default connect(mapStateToProps, actionCreators)(Component);
